/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import {
  FieldValues,
  useController,
  Path,
  PathValue,
} from 'react-hook-form';
import Checkbox, { CheckboxProps } from './index';
import { CommonReactHookFormProps } from '../types';

interface RHFCheckboxProps<
  T, FormFields extends FieldValues,
> extends CheckboxProps<T>, CommonReactHookFormProps<FormFields> {
  onCheckboxChange?: (value: T) => void;
}

function RHFCheckbox<T, FormFields extends FieldValues>(props: RHFCheckboxProps<T, FormFields>) {
  const {
    name,
    control,
    value,
    label,
    disabled,
    onCheckboxChange,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange } = field;

  const handleChange = (event: boolean) => {
    onChange(event);
    if (onCheckboxChange) {
      onCheckboxChange(event as T);
    }
  };

  return (
    <Checkbox
      label={label}
      value={field.value}
      disabled={disabled}
      error={error}
      onChange={handleChange}
      {...rest}
    />
  );
}

RHFCheckbox.defaultProps = {
  onCheckboxChange: () => {},
};

export default RHFCheckbox;
